// Pricing data — supply & install jobs.
// All prices GST inclusive. Edit here to update site-wide.

const TOWPRO_BASIC_VEHICLES = [
  {
    make: "Toyota",
    models: [
      "LandCruiser 20 Series — 1955–1960",
      "LandCruiser 40 Series — 1960–1984",
      "LandCruiser 50 Series (FJ55) — 1967–1980",
      "LandCruiser 60 Series — 1979–1990",
      "LandCruiser 70 Series — 1984–Present",
      "LandCruiser 80 Series — 1990–1997",
      "LandCruiser 100 Series — 1998–2007",
      "LandCruiser 200 Series — 2007–2021",
      "LandCruiser Prado J70 — 1990–1996",
      "LandCruiser Prado J90 — 1996–2002",
      "LandCruiser Prado J120 — 2002–2009",
      "LandCruiser Prado J150 — 2009–2023",
      "Hilux 1st Gen (N10) — 1968–1972",
      "Hilux 2nd Gen (N20) — 1972–1978",
      "Hilux 3rd Gen (N30/N40) — 1978–1983",
      "Hilux 4th Gen (N50/N60) — 1983–1988",
      "Hilux 5th Gen (N80/N90/N100) — 1988–1997",
      "Hilux 6th Gen (N140/N150/N160) — 1997–2005",
      "Hilux 7th Gen (AN10/AN20) — 2005–2015",
      "Hilux 8th Gen (AN120/AN130) — 2015–Present",
      "Fortuner 1st Gen — 2005–2015",
      "Fortuner 2nd Gen — 2015–Present",
    ],
  },
  {
    make: "Isuzu",
    models: [
      "D-MAX 1st Gen — 2002–2011",
      "D-MAX 2nd Gen — 2011–2019",
      "MU-X 1st Gen — 2013–2021",
    ],
  },
  {
    make: "Ford",
    models: [
      "Ranger 1st Gen — 1982–1992",
      "Ranger 2nd Gen — 1993–1997",
      "Ranger 3rd Gen — 1998–2011",
      "Ranger 4th Gen (T6) — 2011–2021",
      "Everest 1st Gen — 2003–2015",
      "Everest 2nd Gen — 2015–2021",
    ],
  },
  {
    make: "Mitsubishi",
    models: [
      "Triton 1st Gen — 1978–1986",
      "Triton 2nd Gen — 1986–1996",
      "Triton 3rd Gen — 1996–2005",
      "Triton 4th Gen — 2005–2015",
      "Triton 5th Gen — 2015–2023",
      "Pajero 1st Gen — 1996–2008",
      "Pajero 2nd Gen — 2008–2015",
      "Pajero 3rd Gen — 2015–Present",
    ],
  },
  {
    make: "Nissan",
    models: [
      "Navara D21 — 1985–1997",
      "Navara D22 — 1997–2014",
      "Navara D40 — 2004–2015",
      "Navara D23 — 2014–2025",
      "Patrol 60 Series — 1959–1980",
      "Patrol 160 Series — 1980–1987",
      "Patrol GQ (Y60) — 1987–1997",
      "Patrol GU (Y61) — 1997–2010",
    ],
  },
  {
    make: "Mazda",
    models: ["BT-50 1st Gen — 2006–2011", "BT-50 2nd Gen — 2011–2020"],
  },
];

const TOWPRO_SMART_VEHICLES = [
  {
    make: "Toyota",
    models: [
      "LandCruiser Prado J250 — 2023–Present",
      "LandCruiser 300 Series — 2021–Present",
    ],
  },
  {
    make: "Isuzu",
    models: ["D-MAX 3rd Gen — 2019–Present", "MU-X 2nd Gen — 2021–Present"],
  },
  {
    make: "Mitsubishi",
    models: ["Triton 6th Gen — 2023–Present"],
  },
  {
    make: "Nissan",
    models: ["Navara D27 — 2025–Present", "Patrol Y62 — 2010–Present"],
  },
  {
    make: "Mazda",
    models: ["BT-50 3rd Gen — 2020–Present"],
  },
];

const TOWPRO_AMAROK_RANGER_VEHICLES = [
  {
    make: "Ford",
    models: [
      "Ranger 5th Gen (Next-Gen / T6.2) — 2022–Present",
      "Everest 3rd Gen (Next-Gen) — 2022–Present",
    ],
  },
  {
    make: "Volkswagen",
    models: [
      "Amarok 1st Gen — 2010–2022",
      "Amarok 2nd Gen — 2022–Present",
    ],
  },
];

export const PRICING = {
  intro:
    "All jobs priced for supply and install — GST included. 1-hour minimum on workshop bookings. Customers come to us from Maroochydore, Caloundra, Noosa, Buderim, Mooloolaba and all Sunshine Coast suburbs from our Kunda Park workshop.",
  tagline:
    "Fair, transparent pricing on every job — no hidden costs.",
  jobs: [
    {
      slug: "grey-anderson-no-relay",
      name: "Grey Anderson Plug",
      variant: "No Relay",
      price: "$495",
      desc: "Supply & install of a grey Anderson plug — without relay. Ideal for direct camper/trailer charging where alternator isolation isn't needed.",
      shopCategory: "towing-electrics",
      image: "/pricing/grey-anderson.jpg",
    },
    {
      slug: "grey-anderson-with-relay",
      name: "Grey Anderson Plug",
      variant: "With Relay",
      price: "$550",
      desc: "Supply & install of a grey Anderson plug with relay — alternator-controlled charging that prevents drawing from the start battery while engine is off.",
      shopCategory: "towing-electrics",
      image: "/pricing/grey-anderson-relay.jpg",
    },
    {
      slug: "12-pin-no-sensors",
      name: "12-Pin Trailer Plug",
      variant: "Without Reverse Sensors • With Relay",
      price: "$495",
      desc: "Supply & install of a basic 12-pin trailer plug with relay. Suits trailers and camper trailers that don't need reverse-sensor disable on tow. Customer must supply a current wiring diagram for the trailer/caravan before booking.",
      shopCategory: "towing-electrics",
      image: "/pricing/12pin-no-sensors.jpg",
      notes: [
        {
          type: "info",
          title: "Basic 12 pin price",
          body: "Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required.",
        },
      ],
    },
    {
      slug: "12-pin-with-sensors",
      name: "12-Pin Trailer Plug",
      variant: "With Reverse Sensors • With Relay",
      price: "$530",
      desc: "Supply & install of a 12-pin trailer plug with reverse-sensor disable and relay. Sensors mute when trailer is connected so they don't trigger off your van/trailer drawbar.",
      shopCategory: "towing-electrics",
      notes: [
        {
          type: "info",
          title: "Basic 12 pin price",
          body: "Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required.",
        },
      ],
      image: "/pricing/12pin-with-sensors.jpg",
    },
    {
      slug: "towpro-basic",
      name: "REDARC Tow-Pro Elite — Basic Install",
      variant: "Plug-and-play vehicles",
      price: "$805",
      desc: "Supply & install of the REDARC Tow-Pro Elite electric brake controller. No diode or extension harness required. Includes a REDARC dash switch blank where applicable. The list below is the vehicles that fall under our Basic install rate.",
      shopCategory: "towing-electrics",
      image: "/pricing/towpro-basic.jpg",
      vehicles: TOWPRO_BASIC_VEHICLES,
    },
    {
      slug: "towpro-smart",
      name: "REDARC Tow-Pro Elite — Smart Install",
      variant: "CAN-bus / late-model vehicles",
      price: "$855",
      desc: "Supply & install of the REDARC Tow-Pro Elite for late-model vehicles requiring a diode kit or extension harness due to CAN-bus / smart-electrical systems. Includes REDARC dash switch blank where applicable.",
      shopCategory: "towing-electrics",
      image: "/pricing/towpro-smart.jpg",
      imagePosition: "center 80%",
      vehicles: TOWPRO_SMART_VEHICLES,
    },
    {
      slug: "towpro-amarok-ranger",
      name: "REDARC Tow-Pro Elite — Amarok & Next-Gen Ranger / Everest",
      variant: "VW Amarok + Ford Next-Gen Ranger / Everest",
      price: "$1,080.38",
      desc: "Supply & install of the REDARC Tow-Pro Elite for VW Amarok and Ford Next-Gen Ranger / Everest. These platforms share a more complex factory tow-package architecture requiring an additional vehicle-specific harness and extended diagnostic time, which is reflected in the price.",
      shopCategory: "towing-electrics",
      image: "/pricing/towpro-amarok-ranger-everest.jpg",
      vehicles: TOWPRO_AMAROK_RANGER_VEHICLES,
    },
    {
      slug: "underglow-kit",
      name: "Underglow Kit — Supply & Install",
      variant: "Full underbody RGB kit — cars & 4WDs",
      price: "$850",
      desc: "Full underbody underglow kit — supply and install. Multi-colour RGB LED strips mounted to all four sides of the vehicle, hard-wired with a properly-fused feed, app or remote control and a hidden switch. Clean loom routing, waterproof rated strips, dust-sealed connections. Legal for off-road / show display use.",
      shopCategory: null,
      image:
        "/gallery/underglow-kit-install-bmw-m3-powerz-auto-electrical-sunshine-coast.webp",
      imagePosition: "center 65%",
    },
    {
      slug: "beacon-buzzer-install",
      name: "Beacon + Buzzer Install",
      variant: "Road Vision low-profile beacon — 1 or 2 beacons",
      price: "$861",
      priceTiers: [
        { label: "1 Beacon", price: "$861" },
        { label: "2 Beacons", price: "$1,000" },
      ],
      desc: "Full beacon + reverse buzzer install — supply and fit of Road Vision low-profile beacon(s), reverse buzzer, switch, relay and mounting bracket. Suits mine-site, work-yard and tradie vehicles requiring OH&S-compliant visible warning. Clean roof-rack / roof-mount install, sealed cable entries, hidden switch behind dash. Multi-flash pattern support.",
      shopCategory: null,
      image:
        "/gallery/beacon-buzzer-install-road-vision-low-profile-powerz-auto-electrical-sunshine-coast.webp",
      imagePosition: "center 45%",
    },
    {
      slug: "ac-service",
      name: "Auto A/C Service",
      tag: "WORKSHOP SERVICE",
      variant: "Cars, 4WDs, utes, trucks & machinery",
      price: "From $154",
      desc: "Starting price — includes a nitrogen pressure test, valve reseal, high & low side system pressure check and a regas. Suits any system that's blowing warm or losing performance.",
      shopCategory: null,
      image: "/pricing/ac-diagnostic.jpg",
      imagePosition: "center 60%",
      notes: [
        {
          type: "legal",
          title: "Important — Australian refrigerant law",
          body: "Under Australian regulations (ARC / Refrigerant Handling Licence), if a leak is detected during diagnostic we are not permitted to simply re-gas the system. The leak must be identified and repaired before refilling — no exceptions. Re-gassing a known-leaky system is illegal and we won't do it.",
        },
      ],
    },
  ],
};
